/**
 * 访问类型
 */
export enum ACCESS_TYPE_ENUM {
  /**
   * 登陆
   */
  LOGIN = 'LOGIN',
  /**
   * 登出
   */
  LOGOUT = 'LOGOUT',
  /**
   * 切换租户/组织
   */
  SWITCH = 'SWITCH',
  /**
   * 跳转
   */
  JUMP = 'JUMP',
}

export const ACCESS_TYPE_LIST = [
  { label: '登录', value: ACCESS_TYPE_ENUM.LOGIN },
  { label: '登出', value: ACCESS_TYPE_ENUM.LOGOUT },
  { label: '切换租户/组织', value: ACCESS_TYPE_ENUM.SWITCH },
  { label: '跳转', value: ACCESS_TYPE_ENUM.JUMP },
];

/**
* 登录方式
*/
export enum LOGIN_FROM_ENUM {
  /**
   * 账号
   */
  ACCOUNT = 'ACCOUNT',
  /**
   * 钉钉
   */
  DINGTALK = 'DINGTALK',
  /**
   * 微信
   */
  WECHAT = 'WECHAT',
  /**
   * 微信小程序
   */
  WECHAT_MINI = 'WECHAT_MINI',
}

export const LOGIN_FROM_LIST = [
  { label: '账号', value: LOGIN_FROM_ENUM.ACCOUNT },
  { label: '钉钉', value: LOGIN_FROM_ENUM.DINGTALK },
  { label: '微信', value: LOGIN_FROM_ENUM.WECHAT },
  { label: '微信小程序', value: LOGIN_FROM_ENUM.WECHAT_MINI },
];
